import { render } from "./accountLayout.vue?vue&type=template&id=6e1bd228&scoped=true&ts=true"
import script from "./accountLayout.vue?vue&type=script&lang=ts"
export * from "./accountLayout.vue?vue&type=script&lang=ts"

import "./accountLayout.vue?vue&type=style&index=0&id=6e1bd228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1bd228"]])

export default __exports__